<template lang="pug">
  a-entity(ref="entity" position="0 0 -15" rotation="0 0 0" @touchstart="onClick" @mousedown="onClick")
    a-entity(geometry='primitive: box' material='src: url(images/common/box-texture.png)')
    a-sphere(color="#ffffff" radius="1.125" material="opacity: 0.25")
</template>
<script>
const debounce = require("lodash/debounce");
import SimplexNoise from "simplex-noise";
export default {
  data() {
    return {
      tick_id: null,
      timestamp: 0,
      simplex: null,
      frame: 0,
      time: 0
    };
  },
  mounted() {
    this.simplex = new SimplexNoise(Math.random);
    this.timestamp = Date.now();
    this.tick();
  },
  computed: {
    rotation: {
      get() {
        return this.$refs.entity.getAttribute("rotation");
      },
      set(value) {
        if (this.$refs.entity)
          this.$refs.entity.setAttribute("rotation", value);
      }
    },
    position: {
      get() {
        return this.$refs.entity.getAttribute("position");
      },
      set(value) {
        if (this.$refs.entity)
          this.$refs.entity.setAttribute("position", value);
      }
    }
  },
  methods: {
    tick() {
      const gapTime = Date.now() - this.timestamp;
      this.timestamp = Date.now();
      this.time += gapTime;
      const offset = Math.min(this.time * 0.0001 - 1, 0);

      let velocity =
        (Math.cos(this.timestamp * 0.001) +
          1.15 * Math.max(0.8, Math.min(window.innerWidth / 640, 1)) +
          Math.pow(offset, 2) * 10) *
        (gapTime * 0.1 * 0.00015) *
        Math.max(0.8, Math.min(window.innerWidth / 640, 1));
      //velocity = 0;
      this.frame += velocity;

      const { frame, simplex } = this;

      const rotation = this.rotation;
      rotation.x += 1;
      rotation.y += 1;
      rotation.z += 1;
      this.rotation = rotation;

      const value1 = simplex.noise3D(frame, 1.0, 1.0) * 2.0;
      const value2 = simplex.noise3D(1.0, frame, 1.0) * 2.0;
      const value3 = simplex.noise3D(1.0, 1.0, frame);
      const radius = (value3 + 1) * Math.min(window.innerWidth / 160, 30) + 10;
      const position = this.position;
      position.x = Math.cos(value1 * Math.PI) * radius;
      position.y = Math.sin(value2 * Math.PI) * radius * 0.5;
      position.z =
        Math.sin(value1 * Math.PI) * radius + Math.pow(offset, 2) * radius * 2;

      this.tick_id = requestAnimationFrame(this.tick);
    },
    onClick: debounce(
      function() {
        cancelAnimationFrame(this.tick_id);
        this.$refs.entity.setAttribute("visible", false);
        this.$store.dispatch("parts/get");
      },
      200,
      { maxWait: 1000 }
    )
  }
};
</script>
